<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Employers Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newEmployer()">New</a>
				</b-navbar-nav>
				<b-navbar-nav>
					<a href="#" @click="saveEmployer()" v-if="employer">Save</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>
		<b-modal id="modConfirm" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" :title="confirmTitle">
			<p class="my-4">{{confirmMessage}}</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="secondary" @click="cancel()">Cancel</b-button>
				<b-button :variant="confirmAction === 'upload' ? 'primary' : 'warning'" @click="confirmCallback()">
					{{confirmAction === 'upload' ? 'Upload' : 'Remove'}}
				</b-button>
			</template>
		</b-modal>
		<div class="row">
			<div class="col-md-3">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<div class="leftSide">
					<b-table :filter="search" striped hover small :items="employers" selectable select-mode="single" :fields="['employers']" @row-clicked="selectEmployer"></b-table>
				</div>
			</div>
			<div class="col-md-8 m-3 mt-0" v-if="employer">
				<div class="row mb-2">
					<h4>{{employer.id}}</h4>
				</div>
				<div class="row mb-2">
					<div class="col-md-3">
						Name: <b-form-input class="mb-2" v-model="employer.name"></b-form-input>
					</div>
					<div class="col-md-4">
						Logo: <b-form-input class="mb-2" v-model="employer.logoUri"></b-form-input>
					</div>
					<div class="col-md-1">
						Gold: <b-form-checkbox class="mb-2" v-model="employer.goldFeeStructure"></b-form-checkbox>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-8">
						Email Whitelist(s): <b-form-textarea rows="4" class="mb-8" v-model="employer.emailDomain"></b-form-textarea>
					</div>
				</div>
				<br/>
				<div class="row mb-2">
					<div class="col-md-4">
						Redeemed Licenses: {{employer.redeemedLicenses}}
					</div>
					<div class="col-md-4">
						Available Licenses: {{employer.availableLicenses}}
						<div v-if="employer.availableLicenses > 0"><b-button v-b-toggle.sidebar size="sm" @click="listLicenses(employer)">Show / Hide</b-button></div>
						<b-sidebar id="sidebar" class="sidebar" title="Licenses" bg-variant="dark" right shadow>
							<div class="px-3 py-2">
								<p>
									<span v-for="l in licenses" :key="l"><br/>{{l}}</span>
								</p>
							</div>
						</b-sidebar>
						<div v-if="employer.availableLicenses < 95"><b-button size="sm" @click="generateLicenses(employer)">Generate Licenses</b-button></div>
					</div>
				</div>
				<br/>
				<br/>
				<div class="row mb-8">
					<div class="col-md-8">
						<p>You do <strong>not need a license</strong> if your email matches the email whitelist.  For license only employers, leave the whitelist empty.</p>
					</div>
				</div>
				<div class="row mb-8">
					<div class="col-md-8">
						<b-button size="sm" v-b-modal.modal-engagement @click="getReport">Engagement Report</b-button>	<b-button v-b-toggle.featuresSidebar size="sm" @click="listFeatures()">App Features</b-button>
					</div>
				</div>

				<b-sidebar id="featuresSidebar" class="sidebar" title="App Features" bg-variant="dark" right shadow>
					<div class="px-3 py-2">
						<p>
							<span v-for="f in employer.features" :key="f.feature.id">
								<br/>{{f.feature.name}} 
								<input type="checkbox" v-model="f.enabled" v-bind:id="f.feature.id" @change=saveEmployer()>
							</span>
						</p>
					</div>
				</b-sidebar>
				
				<div v-show="report" class="report" id="modal-engagement" :title="'Engagement Report for ' + employer.name">
					<b-button @click="report = null">Close</b-button>
					<div v-if="report" style="margin:20px">
						<div class="row mb-2">
							<div class="col-md-3">
								<strong>Employer:</strong> {{employer.name}}
							</div>
							<div class="col-md-3">
								<strong>Registered Customers:</strong> {{report.registeredCustomerCount}}
							</div>
							<div class="col-md-3">
								<strong>Active Customers:</strong> {{report.activeCustomerCount}}
							</div>
							<div class="col-md-3">
								<strong>Dormant Customers:</strong> {{report.dormantCustomerCount}}
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-3">
								<strong>Total Moves Completed:</strong> {{report.totalMovesCompleted}}
							</div>
							<div class="col-md-3">
								<strong>Total Moves Pending:</strong> {{report.totalMovesPending}}
							</div>
							<div class="col-md-3">
								<strong>Avg Completed Moves:</strong> {{report.avgCompletedMoveCountPerCustomer}}
							</div>
							<div class="col-md-3">
								<strong>Avg Pending Moves:</strong> {{report.avgPendingMoveCountPerCustomer}}
							</div>
						</div>
						<br/>
						<div class="row mb-2">
							<div class="col-md-12">
							<b-table :items="report.customerEngagamentReports" :fields="['lastName', {key: 'signupDateString', label: 'Signed Up'}, {key: 'lastLoginDateString', label: 'Last Login'}, 'logins', 'loginsThisMonth', 'loginsLastMonth', 'executedMoves', 'pendingMoves', {key: 'aoiP_Policies', label: 'AIOP Policies'},{key: 'aoiP_Investments', label: 'AIOP Investments'},{key: 'aoiP_CreditAccounts', label: 'AIOP Credit Accounts'},'bankAccounts', 'chatMessages', 'chatMessagesThisMonth', 'chatMessagesLastMonth']"></b-table>
							</div>
						</div>
					</div>	
				</div>
				<br/>
				<div class="row mb-8">
					<div class="col-md-8">
						Employee Benefits Img Url:  <b-form-input class="mb-2" v-model="employer.benefitsHeaderImageUrl"></b-form-input>
					</div>
				</div>
				<br/>
				<div class="row mb-8">
					<div class="col-md-8">
						Employee Benefits Description: <b-form-textarea rows="4" class="mb-8" v-model="employer.benefitsDescription"></b-form-textarea>
					</div>
				</div>
				<br/>
				<div class="row mb-8">
					<div class="col-md-8">
						Chat MG Context Info (the following info is about my employer:):<b-form-textarea rows="4" class="mb-8" v-model="employer.chatMGPrompt"></b-form-textarea>
					</div>
				</div>
				<br/>
				<div class="row mb-8">
					<div class="col-md-8">
						<label>Keys (one per line):</label>
						<b-form-textarea rows="6" class="mb-2" v-model="bulkKeys" placeholder="Paste keys here, one per line"></b-form-textarea>
						<b-button variant="primary" @click="confirmUploadKeys">Upload Keys</b-button>
						<b-button variant="warning" @click="confirmRemoveKeys">Remove Keys</b-button>
					</div>
				</div>
				<br/>
				<p>Knowledge Base File Upload</p>
				<div class="row mb-5">
					<div class="col-md-5 left">
						<input type="file" accept="any/*" @change="onFileSelected" ref="fileInput" />
					</div> 
					<div class="col-md-2">
						<b-button @click="uploadFile">Upload</b-button>
					</div> 
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		employers: null,
		employer: null,
		licenses: null,
		search: "",
		message: null,
		report: null,
		bulkKeys: "",
		confirmTitle: "",
		confirmMessage: "",
		confirmAction: "",
		confirmCallback: null,
		fileName: "",
		file: null,
	}
  },
  methods: {
	list: function(){
		this.$http.get(this.$config.ApiUri + "/Employers")
			.then((result) => {
				this.employers = result.data;
				for (var x = 0; x< this.employers.length; x++)
				{
					this.employers[x].employers = this.employers[x].name;
				}
			}
		)
	},
	listLicenses(e) {
		this.showLicenses = true;
		this.$http.get(this.$config.ApiUri + "/Employers/" + e.id + "/FreeLicenses")
			.then((result) => {
				this.licenses = result.data;
			}
		)
	},
	generateLicenses(e) {
		this.showLicenses = true;
		this.$http.post(this.$config.ApiUri + "/Employers/" + e.id + "/FreeLicenses", null)
			.then(() => {
				this.selectEmployer(e);
			}
		)
	},
	getReport() {
		this.$http.get(this.$config.ApiUri + "/Customers/Reports/Engagement/" + this.employer.id)
			.then((result) => {
				this.report = result.data;
			}
		)
	},
	onLoad() {
		this.list()
	},
	listFeatures() {
		this.showFeatures = true;
	},
	newEmployer(){
		this.employer = {};
		this.employer.name = '';
		this.employer.emailDomain = '';
		this.employer.logoUri = '';
	},
	saveEmployer(){
		if (this.employer.id != null) {
			this.$http.put(this.$config.ApiUri + "/Employers/" + this.employer.id, this.employer)
				.then((result) => {
					this.employer = result.data;
					this.list();
					this.showMessage("Employer saved OK!");
				}
			);
		}
		else {
			this.$http.post(this.$config.ApiUri + "/Employers/", this.employer)
				.then((result) => {
					this.employer = result.data;
					this.list();
					this.showMessage("Employer saved OK!");
				}
			);
		}
	},
	selectEmployer(e){
		this.employer = e;
		this.$http.get(this.$config.ApiUri + "/Employers/" + this.employer.id)
			.then((result) => {
				this.employer = result.data;
				this.listLicenses(e);
			}
		)
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	confirmUploadKeys() {
		const keyCount = this.bulkKeys.split('\n').filter(key => key.trim() !== '').length;
		if (keyCount === 0) {
			this.showError('Please enter some keys to upload');
			return;
		}
		
		this.confirmTitle = "Confirm Upload";
		this.confirmMessage = `Are you sure you want to upload ${keyCount} key(s)?`;
		this.confirmAction = "upload";
		this.confirmCallback = () => {
			this.$bvModal.hide('modConfirm');
			this.uploadKeys();
		};
		this.$bvModal.show('modConfirm');
	},
	confirmRemoveKeys() {
		const keyCount = this.bulkKeys.split('\n').filter(key => key.trim() !== '').length;
		if (keyCount === 0) {
			this.showError('Please enter some keys to remove');
			return;
		}
		
		this.confirmTitle = "Confirm Removal";
		this.confirmMessage = `Are you sure you want to remove ${keyCount} key(s)? This action cannot be undone.`;
		this.confirmAction = "remove";
		this.confirmCallback = () => {
			this.$bvModal.hide('modConfirm');
			this.removeKeys();
		};
		this.$bvModal.show('modConfirm');
	},
	uploadKeys: function() {
		try {
			const keysDataList = this.bulkKeys.split('\n').filter(key => key.trim() !== '');
			
			// Validate the structure
			if (!keysDataList || !Array.isArray(keysDataList) || keysDataList.length === 0) {
				this.showError('Invalid format: missing employee keys');
				return;
			}

			this.$http.post(this.$config.ApiUri + '/Employers/' + this.employer.id + '/CreateEmployerGatewayKeysRequests', {
				employerId: this.employer.id,
				keys: keysDataList
			}).then(response => {
				console.log(response);
				this.showMessage('Employee keys uploaded successfully!');
				this.bulkKeys = '';
				this.selectEmployer(this.employer); // Refresh the employer data
			}).catch(error => {
				this.showError(error.response?.data?.message || 'Failed to upload employee keys. Please try again.');
			});
		} catch (error) {
			console.log(error);
			this.showError('Invalid format');
		}
	},
	removeKeys: function() {
		try {
			const keysDataList = this.bulkKeys.split('\n').filter(key => key.trim() !== '');
			
			// Validate the structure
			if (!keysDataList || !Array.isArray(keysDataList) || keysDataList.length === 0) {
				this.showError('Invalid format: missing employee keys');
				return;
			}

			this.$http.post(this.$config.ApiUri + '/Employers/' + this.employer.id + '/DeleteEmployerGatewayKeysRequests', {
				authCode: this.code,
				employerId: this.employer.id,
				keys: keysDataList
			}).then(response => {
				console.log(response);
				this.showMessage('Employee keys removed successfully!');
				this.bulkKeys = '';
				this.selectEmployer(this.employer); // Refresh the employer data
			}).catch(error => {
				this.showError(error.response?.data?.message || 'Failed to remove employee keys. Please try again.');
			});
		} catch (error) {
			console.log(error);
			this.showError('Invalid format');
		}
	},
	onFileSelected(e) {
			var file = e.target.files[0];
			this.fileName = file.name;
			this.getBase64(file);
		},
	getBase64(file) {
		var reader = new FileReader();
		reader.onload = (e) => {
			this.file = e.target.result.split(',')[1];
		};
		reader.readAsDataURL(file);
	},
	uploadFile() {
		this.$http.post(this.$config.ApiUri + "/Employers/" + this.employer.id + "/KnowledgeBase/UploadRequests", { "content" : this.file, "fileName": this.fileName })
			.then(() => {
				alert("File Uploaded to Employer Knowledge Base OK!");
				this.file = null;
				this.fileName = "";
				this.$refs.fileInput.value = null;
			}
		)
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped>
	.report {
		padding: 20px;
		position: absolute;
		width: 100%;
		background-color: white;
		top: 0px;
		left: 0px;
	}

</style>